module.exports = __webpack_public_path__ + "img/serviceTypes.9e20068a.svg";